import {
  AppInstallOption,
  IntentInstallOptions,
} from '@wix/editor-platform-host-integration-apis';
import { noop } from 'lodash';
import { PluginsEditorType } from '../../../../types/widgetPlugins';
import { getEditorInfo } from '../../../../utils';
import { IntentInstallErrorCode, createIntentInstallError } from '../errors';
import { getIntentAppInfo, getOrigin } from '../helpers';

export function getPluginsEditorType(): PluginsEditorType {
  const host = getEditorInfo()?.host;
  switch (host) {
    case 'EDITOR':
      return PluginsEditorType.Classic;
    case 'EDITOR_X':
      return PluginsEditorType.Responsive;
    case 'STUDIO':
      return PluginsEditorType.Studio;
    case undefined:
      throw createIntentInstallError(IntentInstallErrorCode.NoHostDetected);
    default:
      throw createIntentInstallError(
        IntentInstallErrorCode.UnknownHost,
      ).withHost(host);
  }
}

export function getCommonAppOptions(
  appDefIds: string[],
  options: IntentInstallOptions,
): Record<string, Partial<AppInstallOption>> {
  const { appsOptions } = options;
  const origin = getOrigin(options);
  const intentApp = getIntentAppInfo();

  return appDefIds.reduce((acc, appDefId) => {
    const appVersionIfIntent =
      appDefId === intentApp?.appDefId ? intentApp?.version : undefined;

    const appOptions = appsOptions?.[appDefId];
    acc[appDefId] = {
      origin,
      isSilent: options.isSilent ?? false,
      appVersion: appOptions?.appVersion || appVersionIfIntent,
      ...(appOptions || {}),
    };
    return acc;
  }, {} as Record<string, Partial<AppInstallOption>>);
}

export const createPromiseWithResolvers = <T>() => {
  let resolve: (arg: T) => void = noop;
  let reject: (reason?: unknown) => void = noop;

  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });

  return { promise, resolve, reject };
};
